import * as React from 'react';
import { ConnectedComponentClass } from 'react-redux';
import { ValidationItem } from 'franke-trough-dependencies';
import { ConfigurationKeys } from 'src/api';
import { AccordionItem } from 'src/app/Container';

export interface ConfigurationPartProps {
  btnName: string;
  component: ConnectedComponentClass<any, any>;
  error?: (false | ValidationItem)[];
  id: ConfigurationKeys;
}

export class ConfigurationPart extends React.Component<ConfigurationPartProps, any> {
  public render() {
    const Component = this.props.component;
    return (
      <AccordionItem
        btnName={this.props.btnName}
      >
        <Component />
      </AccordionItem>
    );
  }
}

export default ConfigurationPart;
